"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.outreachStatuses = void 0;
var outreachStatuses;
(function (outreachStatuses) {
    /**
     * The message is pending to be sent to the provider
     */
    outreachStatuses["PENDING"] = "pending";
    /**
     * The message is scheduled to be sent to the provider
     */
    outreachStatuses["SCHEDULED"] = "scheduled";
    /**
     * The message was sent to the provider
     */
    outreachStatuses["SENT"] = "sent";
    /**
     * The message was delivered by the provider
     */
    outreachStatuses["DELIVERED"] = "delivered";
    /**
     * The message was not sent to the provider, or the provider had an error sending the message
     */
    outreachStatuses["ERROR"] = "error";
    /**
     * The message was opened by the patient
     */
    outreachStatuses["OPENED"] = "opened";
    /**
     * The message was received by the patient
     */
    outreachStatuses["RECEIVED"] = "received";
    /**
     * The message was rejected by outreach limiters
     */
    outreachStatuses["REJECTED"] = "rejected";
    /**
     * The message was delayed by outreach limiters
     */
    outreachStatuses["DELAYED"] = "delayed";
    /**
     * The message was opened by the patient and one of the clickable assets was clicked
     */
    outreachStatuses["CLICKED"] = "clicked";
    /**
     * The patient has asked to stop receiving messages of this sort
     */
    outreachStatuses["UNSUBSCRIBED"] = "unsubscribed";
})(outreachStatuses || (exports.outreachStatuses = outreachStatuses = {}));
